import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import ValueSection from "./components/ValueSection";
import FeatureSection from "./components/FeatureSection";
import ComparisonSection from "./components/ComparisonSection";
import ArticleGuideSection from "./components/ArticleGuideSection";
import CTASection from "./components/CTASection";
import TestimonialSection from "./components/TestimonialSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <ValueSection />
      <FeatureSection />
      <ComparisonSection />
      <ArticleGuideSection />
      <CTASection />
      <TestimonialSection />
      <FAQSection />
      <Footer />
    </main>
  );
}